module.exports = __webpack_public_path__ + "img/riskmanagement-graph1.6cdfdc5b.png";